export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AccordionWrapper.vue?vue&type=template&id=7fdf655e&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/AccordionWrapper.vue?vue&type=template&id=7fdf655e&scoped=true
// module id = 166
// module chunks = 0